import React, { useEffect, useRef, useState } from 'react';
import { X, Play } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;
export const WELCOME_VIDEO_URL = '/videos/welcome-dr-ganz.mp4';

export const WelcomeVideoModal = () => {
  const { user, markWelcomeVideoSeen } = useAuth();
  const videoRef = useRef(null);
  const [needsTap, setNeedsTap] = useState(false);
  const lastSent = useRef(0);
  const show = user?.welcomeVideoSeen === false;

  const track = (event) => {
    const v = videoRef.current;
    fetch(`${API}/api/auth/welcome-video-seen`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('dentalToken')}` },
      body: JSON.stringify({ event, seconds: v?.currentTime || 0, duration: v?.duration || 0 }),
    }).catch(() => {});
  };

  useEffect(() => {
    if (!show) return;
    track('shown');
    videoRef.current?.play().catch(() => setNeedsTap(true));
  }, [show]);

  if (!show) return null;

  const onTime = () => {
    const t = videoRef.current?.currentTime || 0;
    if (t - lastSent.current >= 10) { lastSent.current = t; track('progress'); }
  };

  const finish = (event) => {
    track(event);
    videoRef.current?.pause();
    markWelcomeVideoSeen();
  };
  const close = () => finish('closed');

  const playNow = () => {
    setNeedsTap(false);
    videoRef.current?.play().catch(() => {});
  };

  return (
    <div className="fixed inset-0 z-[10000] bg-black/80 flex items-center justify-center p-4" data-testid="welcome-video-modal">
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm sm:max-w-md overflow-hidden">
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <div>
            <p className="font-bold text-gray-900">Welcome to PractCom</p>
            <p className="text-xs text-gray-500">A personal message from Dr. Ganz</p>
          </div>
          <button onClick={close} className="p-2 rounded-full hover:bg-gray-100" aria-label="Close video" data-testid="welcome-video-close-x">
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        <div className="relative bg-black">
          <video ref={videoRef} src={WELCOME_VIDEO_URL} controls playsInline preload="auto" onPlay={() => track('play')} onTimeUpdate={onTime} onEnded={() => finish('ended')}
            className="w-full max-h-[70vh] bg-black" data-testid="welcome-video-player" />
          {needsTap && (
            <button onClick={playNow} className="absolute inset-0 flex items-center justify-center bg-black/40" data-testid="welcome-video-play-btn">
              <span className="w-20 h-20 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                <Play className="w-10 h-10 text-emerald-600 ml-1" />
              </span>
            </button>
          )}
        </div>
        <div className="p-4">
          <Button onClick={close} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="welcome-video-close-btn">
            Close and go to my dashboard
          </Button>
          <p className="text-center text-xs text-gray-500 mt-2">This message plays only once.</p>
        </div>
      </div>
    </div>
  );
};
